import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, Save, Trash2, FlaskConical } from "lucide-react";
import { ContentFields } from "./ContentFields";
import { EmailPreview } from "./EmailPreview";

export const TemplatesPanel = () => {
  const [tpls, setTpls] = useState([]);
  const [sel, setSel] = useState(null);
  const load = (keep) => api.get("/admin/email-templates").then((r) => {
    const list = r.data || []; setTpls(list);
    setSel(list.find((t) => t.id === keep) || list[0] || null);
  }).catch(() => toast.error("Modèles indisponibles"));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { const r = await api.post("/admin/email-templates", { name: "Nouveau modèle" }); load(r.data.id); toast.success("Modèle créé"); } catch { toast.error("Création impossible"); }
  };
  const save = async () => {
    try { await api.put(`/admin/email-templates/${sel.id}`, sel); load(sel.id); toast.success("Modèle enregistré"); } catch { toast.error("Enregistrement impossible"); }
  };
  const remove = async () => {
    if (!window.confirm("Supprimer ce modèle ?")) return;
    try { await api.delete(`/admin/email-templates/${sel.id}`); load(); toast.success("Modèle supprimé"); } catch { toast.error("Suppression impossible"); }
  };
  const test = async () => {
    try { await api.put(`/admin/email-templates/${sel.id}`, sel); const r = await api.post(`/admin/email-campaigns/${sel.id}/test`, {}); toast.success(`Test envoyé à ${r.data.to}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Test impossible"); }
  };

  return (
    <div className="grid gap-4 md:grid-cols-[220px_1fr]" data-testid="templates-panel">
      <div className="space-y-1.5">
        {tpls.map((t) => (
          <button key={t.id} onClick={() => setSel(t)} className={`w-full rounded-xl border px-3 py-2 text-left text-xs ${sel?.id === t.id ? "border-fuchsia-400 bg-fuchsia-500/15 text-white" : "border-white/10 bg-white/[0.03] text-muted-foreground hover:text-white"}`} data-testid={`tpl-item-${t.id}`}>{t.name}</button>
        ))}
        <Button size="sm" variant="outline" className="w-full rounded-full" onClick={create} data-testid="tpl-create"><Plus size={14} className="mr-1" /> Nouveau modèle</Button>
      </div>
      {sel && (
        <div className="grid gap-4 lg:grid-cols-2">
          <div className="space-y-3">
            <Input value={sel.name} onChange={(e) => setSel({ ...sel, name: e.target.value })} data-testid="tpl-name" />
            <ContentFields value={sel} onChange={setSel} prefix="tpl" />
            <div className="flex flex-wrap gap-2">
              <Button size="sm" className="rounded-full bg-fuchsia-500 hover:bg-fuchsia-400" onClick={save} data-testid="tpl-save"><Save size={14} className="mr-1" /> Enregistrer</Button>
              <Button size="sm" variant="outline" className="rounded-full" onClick={test} data-testid="tpl-test"><FlaskConical size={14} className="mr-1" /> Envoyer un test</Button>
              {!sel.builtin && <Button size="sm" variant="ghost" className="rounded-full text-destructive" onClick={remove} data-testid="tpl-delete"><Trash2 size={14} /></Button>}
            </div>
          </div>
          <EmailPreview draft={sel} />
        </div>
      )}
    </div>
  );
};
